var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ILLNESS")]),_c('h4',[_vm._v("A poor health or poor physical condition marked by a pathological deviation from the normal healthy state caused by disease or sickness.")])])
}]

export { render, staticRenderFns }